import interfaceAjax from '@/libs/InterfaceAjax';

export default {
    menuAll() {
        return interfaceAjax({
            url: '/admin/menu/all',
        });
    },
    roleList(params, data) {
        return interfaceAjax({
            url: "/admin/role/list",
            params,
            data
        });
    },
    roleListByType(roleType) {
        return interfaceAjax({
            url: "/admin/role/listByType",
            data:{roleType}
        });
    },
    updateRole(data) {
        return interfaceAjax({
            url: "/admin/role/update",
            data
        });
    },
    addRole(data) {
        return interfaceAjax({
            url: '/admin/role/add',
            data
        });
    },
    deleteRole(id) {
        return interfaceAjax({
            url: '/admin/role/delete',
            data: {id}
        });
    },
    roleUpdateAuth(data) {
        return interfaceAjax({
            url: '/admin/role/updateAuth',
            data
        });
    },
}
